import React from 'react';
import { LockIcon } from 'lucide-react';
import { salesPageData, isPlaceholder } from '../data/salesPageData';
const LINKS = [{
  label: 'Términos y condiciones',
  href: '#'
}, {
  label: 'Política de privacidad',
  href: '#'
}, {
  label: 'Política de reembolso',
  href: '#'
}, {
  label: 'Contacto',
  href: '#'
}];
export function FooterSection() {
  const hasWebsite = !isPlaceholder(salesPageData.website);
  const hasEmail = !isPlaceholder(salesPageData.supportEmail);
  return <footer className="border-t border-[#EFEDE8]/10 bg-[#111111] pb-28 pt-14 md:pb-14" data-id="element-98" data-mp="2kirvk0gtz5dk">
      <div className="mx-auto max-w-content px-4 md:px-8" data-id="element-99" data-mp="2y9wnegdyitdc">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr]" data-id="element-100" data-mp="2ybhhy609ucb7">
          <div data-id="element-101" data-mp="2tiohvvfqzs5g">
            <div className="flex items-center gap-2.5" data-id="element-102" data-mp="2ti55svcs3xzc">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-[#D89A3D]/40 bg-[#181512]" data-id="element-103" data-mp="25tlyai1jzp8b">
                <LockIcon className="h-4 w-4 text-[#FF7A00]" aria-hidden="true" data-id="element-104" data-mp="20vapmamzvkro" />
              </span>
              <span className="font-display text-xs font-extrabold uppercase tracking-[0.14em] text-[#F8F3EA]" data-id="element-105" data-mp="1ghhsz2b2lgmz">
                La Bóveda del Carpintero™
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#EFEDE8]/60" data-id="element-106" data-mp="1q5zslg7m5hp1">
              {salesPageData.tagline}
            </p>
            {(hasWebsite || hasEmail) && <div className="mt-4 space-y-1 text-sm text-[#EFEDE8]/55" data-id="element-107" data-mp="1v7faizehv837">
                {hasWebsite && <p data-id="element-108" data-mp="xjykbzsiy013">{salesPageData.website}</p>}
                {hasEmail && <p data-id="element-109" data-mp="12hzzwaqqrh7t">
                    Soporte:{' '}
                    <a href={`mailto:${salesPageData.supportEmail}`} className="text-[#D89A3D] underline underline-offset-4" data-id="element-110" data-mp="17g1kj03tfole">
                      {salesPageData.supportEmail}
                    </a>
                  </p>}
              </div>}
          </div>

          <nav aria-label="Enlaces legales" data-id="element-111" data-mp="2iungljjqyl6a">
            <ul className="grid gap-2.5 sm:grid-cols-2 md:grid-cols-1" data-id="element-112" data-mp="2mws6q8azkzo6">
              {LINKS.map(link => <li key={link.label} data-id="element-113" data-mp="ns0j234tfuv3">
                  <a href={link.href} className="text-sm text-[#EFEDE8]/60 transition-colors hover:text-[#FF7A00]" data-id="element-114" data-mp="nqz77wfz74cb">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-10 rounded-lg border border-[#EFEDE8]/10 bg-[#181512] px-4 py-3 text-center font-display text-[11px] font-extrabold uppercase tracking-[0.14em] text-[#D89A3D]" data-id="element-115" data-mp="wrxbmfubtdvf">
          Producto 100% digital. No se realizan envíos físicos.
        </p>

        <div className="mt-8 space-y-4 border-t border-[#EFEDE8]/10 pt-8 text-xs leading-relaxed text-[#EFEDE8]/45" data-id="element-116" data-mp="3hb5opohk3j">
          <p data-id="element-117" data-mp="dvfd9fkz2fq7">
            Los resultados obtenidos utilizando el material pueden variar según la
            experiencia, ejecución, herramientas, materiales, dedicación, precios y
            condiciones particulares de cada persona y mercado. La Bóveda del Carpintero
            no garantiza ingresos, ventas ni resultados económicos específicos.
          </p>
          <p data-id="element-118" data-mp="1s1acxj6nrnvn">
            © 2026 La Bóveda del Carpintero. Todos los derechos reservados. El contenido
            incluido en este producto no puede ser reproducido, revendido, compartido ni
            distribuido sin autorización, salvo los usos expresamente permitidos en los
            términos correspondientes.
          </p>
        </div>
      </div>
    </footer>;
}